import React from 'react';

const ProductInfoSection = ({ 
  productName, 
  setProductName, 
  productDesc, 
  setProductDesc, 
  reference, 
  setReference, 
  barcode, 
  setBarcode 
}) => {
  return (
    <div className="sm:col-span-6">
      <div className="border-b border-gray-200 pb-2">
        <h3 className="text-lg font-medium leading-6 text-gray-900">Informations du produit</h3>
        <p className="mt-1 text-sm text-gray-500">Les champs marqués d'un * sont obligatoires</p>
      </div>
      
      <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 pt-2">
        {/* Product Name */}
        <div className="sm:col-span-6">
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
            Nom du produit <span className="text-red-500">*</span>
          </label>
          <div className="mt-1">
            <input
              type="text"
              name="name"
              id="name"
              value={productName}
              onChange={(e) => setProductName(e.target.value)}
              className="block w-full focus:ring-[#174540] focus:border-[#174540] pl-3 py-2 sm:text-sm border border-gray-300 rounded-md"
              placeholder="ex: Smartphone Samsung Galaxy S21"
              required
            />
          </div>
        </div>

        {/* Product Description */}
        <div className="sm:col-span-6">
          <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">
            Description du produit
          </label>
          <div className="mt-1">
            <textarea
              name="description"
              id="description"
              rows="4"
              value={productDesc}
              onChange={(e) => setProductDesc(e.target.value)}
              className="block w-full focus:ring-[#174540] focus:border-[#174540] pl-3 py-2 sm:text-sm border border-gray-300 rounded-md"
              placeholder="Décrivez les caractéristiques et avantages du produit..."
            />
          </div>
        </div>

        {/* Reference */}
        <div className="sm:col-span-3">
          <label htmlFor="reference" className="block text-sm font-medium text-gray-700 mb-1">
            Référence <span className="text-red-500">*</span>
          </label>
          <div className="mt-1">
            <input
              type="text"
              name="reference"
              id="reference"
              value={reference}
              onChange={(e) => setReference(e.target.value)}
              className="block w-full focus:ring-[#174540] focus:border-[#174540] pl-3 py-2 sm:text-sm border border-gray-300 rounded-md"
              placeholder="ex: REF-12345"
              required
              disabled
            />
          </div>
        </div>

        {/* Barcode */}
        <div className="sm:col-span-3">
          <label htmlFor="barcode" className="block text-sm font-medium text-gray-700 mb-1">
            Code à barres
          </label>
          <div className="mt-1">
            <input
              type="text"
              name="barcode"
              id="barcode"
              value={barcode}
              onChange={(e) => setBarcode(e.target.value)}
              className="block w-full focus:ring-[#174540] focus:border-[#174540] pl-3 py-2 sm:text-sm border border-gray-300 rounded-md"
              placeholder="ex: 123456789012"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductInfoSection;